export default {
  mainPage: 'Página principal',
  additionalInformationAdded: 'Información adicional agregada',
  assignOrSelectTheNameFromTheList: 'Asigna o selecciona el nombre de la lista',
  AddPeopleToAnExistingList: 'Agregar personas a una lista existente',
  updateList: 'Actualizar lista',
  eventModified: 'Evento modificado',
  completeTheRequiredFields: 'Complete los campos requeridos',
  anErrorHasOcurred: 'Ocurrió un error',
  insertKeybeUiOnYourWebsite: 'Insertar Keybe UI en tu página web',
  toInsertKeybeUiIntoYourWebsiteYouMustCreateADivElementWithTheIdKeybe: ' Para insertar KeybeUI a tu página web, debes crear un elemento DIV con el ID \'keybe\' en el body de tu sitio',
  andThenAddTheFollowingScriptInTheFooterOfYourSite: 'Y luego agregar el siguiente Script en el Footer de tu sitio',
  toAddElementsInTheDOMToOpenTheKeybeUIYouCanUseAScriptSimilarToTheFollowing: 'Para agregar elementos en el DOM que permitan abrir el KeybeUI, puedes usar un script similar al siguiente',
  selectProfilePhoto: 'Seleccionar foto de perfil',
  selectPhoto: 'Seleccionar foto',
  photoSuccessfullyUpdated: 'Foto actualizada correctamente',
  select: 'Seleccionar',
  numeric: 'Numerico',
  dependent: 'Dependiente',
  options: 'Opciones',
  editOption: 'Editar opción',
  dependence: 'Dependencia',
  fieldOnWhichItDepends: 'Campo del que depende',
  theFieldMustNotBeTheSame: 'El campo no debe ser igual',
  pressEnterToAddOptionOrPasteFromAnExcel: 'Presiona ENTER para agregar opción o pega desde un Excel',
  includeOptionOthers: 'Incluir opción Otros',
  help: 'Ayuda',
  helpSimpleOptions: 'Puedes copiar opciones desde un archivo de excel. Al copiar debe tener la distribución mostrada en la imagen.',
  helpDependentOptions: 'Las opciones que no tengan dependencias no serán agregadas.',
  ok: 'Aceptar',
  errorGettingTheForm: 'Error obteniendo el formulario'
}
